module.exports = __webpack_public_path__ + "static/img/aniCloudBg.354afa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aniCloudBg.png
// module id = H5/1
// module chunks = 2